import ApiRequest from "../utils/apiRequest"

export default class Scan {
    static qrScan = async (body) => {
        return await ApiRequest.set("v1/qr/scanV2", "POST", body)
    }
}